import { IsArray, IsString } from 'class-validator';

export class ProvisionAbandonedCartsFlowDto {
	@IsArray()
	@IsString({ each: true })
	public tenantAliases!: Array<string>;
}
